<template>
    <div class="content__inner" v-if="!loading">
        <keep-alive>
            <component :is="viewComponent" :current-user="currentUser" />
        </keep-alive>
    </div>
</template>
<script>
import currentUserQuery from '@views/Setup/View/queryCurrentUser.graphql';
import AccountManager from './AccountManager';
import ContractorManager from './ContractorManager';
import CropTypeManager from './CropTypeManager';
import GrowsafeManager from './GrowsafeManager';
import OrchardMapManager from './OrchardMapManager';
import PackageManager from './PackageManager';
import ProcessorCropTypeManager from './ProcessorCropTypeManager';
import ProcessorManager from './ProcessorManager';
import RegionManager from './RegionManager';
import EquipmentManager from './EquipmentManager';

export default {
  name: 'Setup',
  components: {
    CropTypeManager,
    PackageManager,
    ProcessorCropTypeManager,
    ProcessorManager,
    GrowsafeManager,
    OrchardMapManager,
    RegionManager,
    ContractorManager,
    AccountManager,
    EquipmentManager,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  computed: {
    viewComponent() {
      switch (this.view) {
        case 'crop-types':
          return CropTypeManager;
        case 'processor-crop-types':
          return ProcessorCropTypeManager;
        case 'account':
          return AccountManager;
        case 'contractors':
          return ContractorManager;
        case 'processors':
          return this.currentUser.is_processor_managed ? AccountManager : ProcessorManager;
        case 'growsafe':
          return GrowsafeManager;
        case 'regions':
          return RegionManager;
        case 'packages':
          return PackageManager;
        case 'equipment':
          return EquipmentManager;
        case 'orchard-maps':
          return OrchardMapManager;
        default:
          return AccountManager;
      }
    },
  },
  props: {
    view: {
      type: String,
      default: 'account',
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
  methods: {
    changeView(view) {
      this.$router.push({ name: 'setup', params: { view } });
    },
  },
};
</script>

